import {
  WOG_brandVariables,
  Elgiganten_brandVariables,
  DBG_brandVariables,
  BESTGAMER_brandVariables,
  LEGO_brandVariables,
  Logitechg_brandVariables,
  Gigantti_brandVariables,
} from "./brands/index";
import BrandProps from "./brands/BrandProps";
import WinnerDataProps from "./winnersData/WinnersDataProps";
import { FormattedListType } from "@/components/ListByDay/types/winnersTypes";

const brands = {
  "localhost:5173": {
    brandData: Elgiganten_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Set for local development

  "localhost:5174": {
    brandData: LEGO_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Set for local development

  "192.168.1.153:5173": {
    brandData: DBG_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Set for local development

  "elgiganten.iplay.dk": {
    brandData: Elgiganten_brandVariables,
    // winnersPageData: undefined,
    // schedulePageData: undefined,
  }, // Elgiganten

  "gigantti.iplay.dk": {
    brandData: Gigantti_brandVariables,
    // winnersPageData: undefined,
    // schedulePageData: undefined,
  }, // Gigantti

  "elgiganten.web.app": {
    brandData: Elgiganten_brandVariables,
    // winnersPageData: undefined,
    // schedulePageData: undefined,
  }, // Elgiganten

  "lego.iplay.dk": {
    brandData: LEGO_brandVariables,
    // winnersPageData: undefined,
    // schedulePageData: undefined,
  }, // Elgiganten

  "logitechg.iplay.dk": {
    brandData: Logitechg_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Logitech

  "dev.danmarksbedstegamer.dk": {
    brandData: DBG_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Set for local development

  "app.danmarksbedstegamer.dk": {
    brandData: DBG_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Set for local development

  default: {
    brandData: WOG_brandVariables,
    // winnersPageData: JBL_winnersBrandVariables,
    // schedulePageData: LEGION_scheduleBrandVariables,
  }, // Fallback to WOG

  // Brands, can be called individualy with getBrandVariables(client)
  WOG: WOG_brandVariables,
  DBG: DBG_brandVariables,
  ELGIGANTEN: Elgiganten_brandVariables,
  BG: BESTGAMER_brandVariables,
  LEGO: LEGO_brandVariables,
};

export const getBrandVariables = (client?: string) => {
  if (client) {
    const brandVariables = brands[client];

    return brandVariables as {
      brandData: BrandProps;
      winnersPageData: WinnerDataProps;
      schedulePageData: {
        header: string;
        subHeader: string;
        sideMenuTitle: string;
        scheduleData: FormattedListType[];
      };
    };
  } else {
    const hostname = window.location.host;
    const brandVariables = brands[hostname] || brands["default"];
    return brandVariables as {
      brandData: BrandProps;
      winnersPageData: WinnerDataProps;
      schedulePageData: {
        header: string;
        subHeader: string;
        sideMenuTitle: string;
        scheduleData: FormattedListType[];
      };
    };
  }
};

export const brand = getBrandVariables().brandData;
export const winnerData = getBrandVariables().winnersPageData;
export const scheduleData = getBrandVariables().schedulePageData;
